<template>
    <div class="float-left">
        <b-button
        variant="success"
        @click="abrirModal()">
            Adicionar Ação
        </b-button>
        <acao-form
            operacaoProp="I"
            :pleito="pleito"
            :mostrarModal="mostrarModal"
            :erros="erros"
            :dataServicos="dataServicos"
            @fechar="fecharModal()"
            @salvar="salvar($event)"
        ></acao-form>
    </div>
</template>

<script>
import AcaoForm from './AcaoForm'

export default {
    components: {
        AcaoForm
    },

    props: {
        pleito: {
            type: Object,
        },
        dataServicos: {
            type: Object
        },
    },

    data() {
        return {
            mostrarModal: false,
            erros: [],
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
        },

        salvar(acao){
            this.$store.dispatch('addRequest')
            let acaoDto = {
                pleitoId : this.pleito.pleitoId,
                nomeAcao: acao.nomeAcao,
                dataInicio: this.$moment(acao.dataInicio,'DD/MM/YYYY').format('YYYY-MM-DD'),
                dataFim: this.$moment(acao.dataFim,'DD/MM/YYYY').format('YYYY-MM-DD'),
                codUnidade: acao.codUnidade,
            }
            this.dataServicos.inserirAcao(acaoDto)
            .then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Ação inserida com sucesso',
                            'OK',
                            this.$toastConfig.success)
                        this.$emit('atualizarLista')
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
            this.fecharModal()
        },
    }
}
</script>
